




























































































import Vue from 'vue';
import { AxiosError } from 'axios';
import {
  ItemCommercialTranslation,
  ItemCommercialTranslationFieldError,
  IItemCommercialTranslation
} from '@/models';

import { ALForm } from '@/common/component.types';

import { mapActions, mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';
import { ErrorManager } from '@/models/error';
import { diffDeep } from '@/utils/helpers';

import ALDialog from '../core/Dialog/ALDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

export interface Options extends InstanceType<typeof Vue> {
  $refs: {
    form: ALForm;
  };
}

export default Vue.extend<Options>({
  functional: false
}).extend({
  name: 'ItemCommercialTranslationDetailFormDialog',

  components: { ALDialog, ErrorAlert },

  data: () => ({
    loading: false,
    isEdit: false,
    dialog: false,
    currencyLoading: false,
    itemCommercialTranslationOriginalCopy: null as null | IItemCommercialTranslation,
    itemCommercialTranslation: null as null | IItemCommercialTranslation,
    fieldError: new ItemCommercialTranslationFieldError(),

    errorMessage: '',
    detailErrorMessage: '',

    isFileValid: false,

    languageChoices: [
      {
        text: 'English (United States)',
        value: 'en-US'
      },
      {
        text: 'Russian (Russia)',
        value: 'ru-RU'
      },
      {
        text: 'Spanish (Spain)',
        value: 'es-ES'
      }
    ],

    requiredRules: [(v: string) => !!v || 'This field is required']
  }),

  computed: {
    ...mapGetters({
      currencies: 'currencyNew/getCurrencies'
    })
  },

  methods: {
    ...mapActions({
      fetchCurrencies: 'currencyNew/fetchCurrencies',
      createItemCommercialTranslation:
        'itemCommercialTranslation/createItemCommercialTranslation',
      updateItemCommercialTranslation:
        'itemCommercialTranslation/updateItemCommercialTranslation'
    }),

    resetFormValidation(): void {
      if (this.$refs.form) {
        return this.$refs.form.resetValidation();
      }
    },

    validateForm(): boolean {
      let valid = false;
      if (this.$refs.form) {
        valid = this.$refs.form.validate();
      }
      return valid;
    },

    selectLanguage(language: string) {
      const languageChoice = this.languageChoices.find(
        ({ value }) => value == language
      )?.value;

      if (languageChoice) {
        switch (languageChoice) {
          case 'en-US':
            this.itemCommercialTranslation!.language_code = 'ENU';
            this.itemCommercialTranslation!.language_description =
              'English (United States)';
            break;
          case 'ru-RU':
            this.itemCommercialTranslation!.language_code = 'RUS';
            this.itemCommercialTranslation!.language_description =
              'Russian (Russia)';
            break;
          case 'es-ES':
            this.itemCommercialTranslation!.language_code = 'ESP';
            this.itemCommercialTranslation!.language_description =
              'Spanish (Spain)';
            break;
          default:
            this.itemCommercialTranslation!.language_code = 'ENU';
            this.itemCommercialTranslation!.language_description =
              'English (United States)';
            break;
        }
      }
    },

    open(
      itemCommercialTranslation: IItemCommercialTranslation = new ItemCommercialTranslation(),
      isEdit = false
    ) {
      this.itemCommercialTranslationOriginalCopy = itemCommercialTranslation;
      this.itemCommercialTranslation = cloneDeep(
        this.itemCommercialTranslationOriginalCopy
      );
      this.isEdit = isEdit;
      this.clearAllErrors();
      this.dialog = true;

      this.resetFormValidation();
    },

    close() {
      this.dialog = false;
    },

    clearAllErrors(): void {
      this.fieldError.clearErrors();
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async saveItemCommercialTranslation(): Promise<void> {
      if (this.validateForm()) {
        this.clearAllErrors();

        this.loading = true;

        try {
          if (this.isEdit) {
            const itemCommercialTranslationDelta = diffDeep(
              this.itemCommercialTranslation,
              this.itemCommercialTranslationOriginalCopy,
              true
            );
            itemCommercialTranslationDelta!.id = this.itemCommercialTranslation!.id;
            await this.updateItemCommercialTranslation(
              itemCommercialTranslationDelta
            );
          } else {
            await this.createItemCommercialTranslation(
              this.itemCommercialTranslation
            );
          }

          this.loading = false;
          this.close();
          // reset error state of text fields
          this.itemCommercialTranslation = null;
        } catch (err) {
          const error = err as AxiosError;
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        } finally {
          this.loading = false;
        }
      }
    }
  }
});
